import * as Types from '../../api/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type SetUserMutationVariables = Types.Exact<{
  data: Types.VisitorInput;
}>;


export type SetUserMutation = { __typename?: 'Mutation', SetUser?: { __typename?: 'Visitor', name?: string | null, email?: string | null, image?: string | null, attributes?: Array<{ __typename?: 'VisitorAttributeCategory', name: string, attributes?: Array<{ __typename?: 'VisitorAttribute', name: string, value: string, type: Types.VisitorAttributeType } | null> | null } | null> | null } | null };


export const SetUserDocument = gql`
    mutation SetUser($data: VisitorInput!) {
  SetUser(data: $data) {
    name
    email
    image
    attributes {
      name
      attributes {
        name
        value
        type
      }
    }
  }
}
    `;
export type SetUserMutationFn = ApolloReactCommon.MutationFunction<SetUserMutation, SetUserMutationVariables>;

/**
 * __useSetUserMutation__
 *
 * To run a mutation, you first call `useSetUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserMutation, { data, loading, error }] = useSetUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetUserMutation, SetUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetUserMutation, SetUserMutationVariables>(SetUserDocument, options);
      }
export type SetUserMutationHookResult = ReturnType<typeof useSetUserMutation>;
export type SetUserMutationResult = ApolloReactCommon.MutationResult<SetUserMutation>;
export type SetUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SetUserMutation, SetUserMutationVariables>;